export function operacaoRadAprovarPreFaturaInRequest(params = {}) {
  return {
    type: '@operacaoradaprovarprefatura/RADAPROVARPREFATURA_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoRadAprovarPreFatura(fatu_codigo) {
  return {
    type: '@operacaoradaprovarprefatura/FIND_RADAPROVARPREFATURA',
    payload: { fatu_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoradaprovarprefatura/FAILED_REQUEST',
  };
}

export function deleteOperacaoRadAprovarPreFatura(fatu_codigo, params) {
  return {
    type: '@operacaoradaprovarprefatura/DELETE_RADAPROVARPREFATURA',
    payload: { fatu_codigo, params },
  };
}

export function updateOperacaoRadAprovarPreFatura(
  operacaoradaprovarprefatura,
  params
) {
  return {
    type: '@operacaoradaprovarprefatura/UPDATE_RADAPROVARPREFATURA',
    payload: { operacaoradaprovarprefatura, params },
  };
}

export function storeOperacaoRadAprovarPreFatura(
  operacaoradaprovarprefatura,
  params
) {
  return {
    type: '@operacaoradaprovarprefatura/STORE_RADAPROVARPREFATURA',
    payload: { operacaoradaprovarprefatura, params },
  };
}

export function successInRequest(
  operacaoradaprovarprefatura,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoradaprovarprefatura/SUCCESS_IN_REQUEST',
    payload: {
      operacaoradaprovarprefatura,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaoradaprovarprefatura) {
  return {
    type: '@operacaoradaprovarprefatura/SUCCESS_REQUEST',
    payload: { operacaoradaprovarprefatura },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoradaprovarprefatura/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoradaprovarprefatura/RECORD_FILTERING',
    payload: { params },
  };
}
